// @flow
export const header_height = 50;
export const default_transition = "transition: all 0.2s linear;";